export default {"src":"/_next/static/media/docEnVille75.297460dc.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};